import { ref } from 'vue'

// Module scope, not component state: the badge, the banner and the empty state all
// toggle the same panel and none of them is an ancestor of it.
const isOpen = ref(false)

// The assistant step's instruction and the button it is describing are at
// opposite ends of the screen, so the step tells the widget when to draw
// attention to itself. The drawer decides: it is the only thing that knows which
// step is expanded and whether it is still outstanding.
const assistantStepActive = ref(false)

export function setAssistantStepActive(active) {
  assistantStepActive.value = Boolean(active)
}

export function openSetupDrawer() {
  isOpen.value = true
}

export function closeSetupDrawer() {
  isOpen.value = false
  assistantStepActive.value = false
}

export function toggleSetupDrawer() {
  isOpen.value = !isOpen.value
}

export function useSetupDrawer() {
  return {
    isOpen,
    assistantStepActive,
    open: openSetupDrawer,
    close: closeSetupDrawer,
    toggle: toggleSetupDrawer,
    setAssistantStepActive
  }
}
